import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const MenuSection = () => {
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const menuData = [
    { category: 'Breakfast', path: 'breakfast' },
    { category: 'Combo', path: 'combo' },
    { category: 'Extra-Sides', path: 'extra-sides' },
    { category: 'Fisherman Delight', path: 'fisherman-delight' },
    { category: 'Grills', path: 'grills' },
    { category: 'Hot Beverages', path: 'hot-beverages' },
    { category: 'MilkShakes', path: 'milkshakes' },
    { category: 'Nigerian-Soups', path: 'nigerian-soups' },
    { category: 'Noodles', path: 'noodles' },
    { category: 'Pasta', path: 'pasta' },
    { category: 'Pastry', path: 'pastry' },
    { category: 'Peppersoup', path: 'peppersoup' },
    { category: 'Pizza', path: 'pizza' },
    { category: 'Salad', path: 'salad' },
    { category: 'Sandwiches', path: 'sandwiches' },
    { category: 'Shawarma', path: 'shawarma' },
    { category: 'Smoothies', path: 'smoothies' },
    { category: 'Soft Drinnks', path: 'softdrinks' },
    { category: 'Suya-Spot', path: 'suya' }
  ];
  
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Sidebar for tablets and desktops */}
      <div className="hidden sm:block fixed inset-y-0 left-0 bg-black z-10 sm:w-44 lg:w-48">
        <div className="h-full pt-20">
          <div className="h-full overflow-y-auto">
            <div className="p-3 sm:p-3 lg:p-4">
              <h2 className="text-lg sm:text-lg lg:text-xl text-red-500 mb-3 lg:mb-4">Categories</h2>
              <nav className="flex flex-col gap-1 sm:gap-1 lg:gap-2">
                {menuData.map((category) => (
                  <NavLink
                    key={category.category}
                    to={category.path}
                    className={({ isActive }) =>
                      `px-2 sm:px-2 lg:px-3 py-1 sm:py-1 lg:py-2 rounded text-lg ${
                        isActive
                          ? 'bg-red-600 text-white'
                          : 'hover:bg-gray-700 text-white'
                      }`
                    }
                  >
                    {category.category}
                  </NavLink>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE: Dropdown container below the navbar */}
      <div
        className="sm:hidden sticky bg-black z-[40]"
        style={{ top: '80px' }}
      >
        <div className="max-w-7xl mx-auto px-4 pt-4 pb-2">
          <button
            onClick={() => setIsCategoryDropdownOpen(!isCategoryDropdownOpen)}
            className="w-full flex items-center justify-between px-4 py-2 bg-red-500 rounded-lg text-white"
          >
            <span>
              {menuData.find((category) =>
                window.location.pathname.includes(category.path)
              )?.category || 'Categories'}
            </span>
            <ChevronDown
              className={`w-5 h-5 transition-transform ${
                isCategoryDropdownOpen ? 'rotate-180' : ''
              }`}
            />
          </button>
          {isCategoryDropdownOpen && (
            <div className="mt-2 w-full px-4">
              <div className="bg-red-500 rounded-lg py-2 shadow-xl flex flex-col gap-2 max-h-96 overflow-y-auto">
                {menuData.map((category) => (
                  <NavLink
                    key={category.category}
                    to={category.path}
                    onClick={() => setIsCategoryDropdownOpen(false)}
                    className={({ isActive }) =>
                      `px-4 py-2 text-lg ${
                        isActive
                          ? 'bg-red-600 text-white'
                          : 'text-white hover:bg-gray-700'
                      }`
                    }
                  >
                    {category.category}
                  </NavLink>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Outlet Content: Adjusted margin to match sidebar width */}
      <div className="sm:ml-44 lg:ml-48 min-h-screen mt-[100px] sm:mt-0">
        <div className="max-w-7xl mx-auto px-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MenuSection;
